import { Button } from "@/components/ui/button";
import { Check, Eye } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useAccountsTableInstanceContext } from "./table-instance-provider";

export const AutomaticAccountsFilter = () => {
  const { t } = useTranslation();
  const { table } = useAccountsTableInstanceContext();
  const [showOnlyAutomatic, setShowOnlyAutomatic] = useState(false);

  const handleFilterToggle = () => {
    const newState = !showOnlyAutomatic;
    setShowOnlyAutomatic(newState);

    if (newState) {
      // Filter to show only automatic accounts
      table.setColumnFilters([
        {
          id: "automatic",
          value: true,
        },
      ]);
    } else {
      // Clear the filter to show all accounts
      table.setColumnFilters([]);
    }
  };

  return (
    <Button
      variant={"outline"}
      onClick={handleFilterToggle}
      className={`h-10 ${showOnlyAutomatic ? "border-dashed bg-secondary" : ""}`}
    >
      {showOnlyAutomatic ? (
        <Check className="w-4 h-4 mr-2" />
      ) : (
        <Eye className="w-4 h-4 mr-2" />
      )}
      {t("accounts.filter_automatic")}
    </Button>
  );
};
